module.exports = __webpack_public_path__ + "img/futures.4f630461.png";